/* eslint-disable @typescript-eslint/no-unused-vars */
/* Autogenerated, do not modify! */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import SvgIcon from '@move-ui/svg-icon';
export const PriceDropBellIcon = (_a) => {
    var { fillColor = 'currentColor', strokeColor = 'currentColor' } = _a, svg = __rest(_a, ["fillColor", "strokeColor"]);
    return (React.createElement(SvgIcon, Object.assign({ width: "16", height: "16", fill: "none", viewBox: "0 0 16 16", "data-icon": true }, svg),
        React.createElement("path", { fill: fillColor, d: "M12.638 6.82V6.398c0-2.356-1.743-4.304-3.99-4.59v-0.23A0.574 0.574 0 008.08 1a0.574 0.574 0 00-0.57 0.578v0.23c-2.246 0.286-3.99 2.234-3.99 4.59V6.82a6.542 6.542 0 01-1.394 4.035 0.586 0.586 0 00-0.069 0.612 0.57 0.57 0 000.514 0.328h11.018a0.57 0.57 0 000.514-0.328 0.585 0.585 0 00-0.069-0.612 6.542 6.542 0 01-1.395-4.035zM9.75 12.568a0.56 0.56 0 010.26 0.044 0.582 0.582 0 010.303 0.758 2.464 2.464 0 01-1.29 1.31 2.386 2.386 0 01-0.946 0.194 2.383 2.383 0 01-0.945-0.194 2.461 2.461 0 01-1.291-1.31 0.582 0.582 0 010.303-0.758 0.56 0.56 0 010.263-0.044V12.56h3.344v0.007z" })));
};
//# sourceMappingURL=PriceDropBellIcon.js.map